import React, { useState } from "react";

import { Header, Icon, Table } from "semantic-ui-react";

import { PracticeInformationBody } from "./components";

function PracticeInformation() {
  const [footerMessage, setFooterMessage] = useState();

  return (
    <div style={{ marginTop: "1em" }}>
      <Header as="h1" style={{ margin: "0" }}>
        Practice Information
      </Header>

      <Table data-test="practice-information-table">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={7}>Name</Table.HeaderCell>
            <Table.HeaderCell width={7}>Billing Contact</Table.HeaderCell>
            <Table.HeaderCell width={2} />
          </Table.Row>
        </Table.Header>
        <PracticeInformationBody onChange={setFooterMessage} />
      </Table>

      {footerMessage && (
        <div>
          <Icon name="warning sign" color="yellow" />
          <span>{footerMessage}</span>
        </div>
      )}
    </div>
  );
}

export default PracticeInformation;
